<div class="modal-content" *ngIf="!isCreateProfile; else CreateNewProfile">
  <div class="modal-header">
    <h4 class="modal-title">{{ savedRouteName }}</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="!isLoading; else loading">
      <div class="card">
        <div class="card-body p-0">
          <div class="d-flex justify-content-start">
            <P
              >The imported vehicle routing profile settings match the existing
              profile &#32;&#32;<b>{{ existingProfileName }}</b
              >&#32;&#32;would you like to use this for this route or create new
              one?
            </P>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #loading>
      <div class="px-3">
        <div class="text-center text-primary">
          <div class="spinner-border"></div>
          <div class="h3 text-primary mt-3">Loading...</div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="modal-footer">
    <button
      [disabled]="isLoading"
      (click)="createProfile()"
      class="btn btn-outline-dark"
    >
      Create Vehicle Routing Profile
    </button>

    <button
      (click)="useExitingProfile()"
      [disabled]="isLoading"
      class="btn btn-primary"
    >
      Use Existing Profile
    </button>
  </div>
</div>
<ng-template #CreateNewProfile>
  <div class="modal-content" *ngIf="isCreateProfile">
    <div class="modal-header">
      <h4 class="modal-title">{{ savedRouteName }}</h4>
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="bsModalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="card">
        <div class="card-body p-0">
          <div class="d-flex justify-content-start" *ngIf="!exceedVehicleType">
            <P
              >We've imported your existing Vehicle Routing Profile settings for
              this route and will create new custom profile for you.Please give
              your new profile name.
            </P>
          </div>
          <div class="d-flex justify-content-start" *ngIf="exceedVehicleType">
            <P
              >The vehicle dimension value exceeds the required limits of
              vehicle type <b>{{ existingVehicleType }}</b
              >. please click save to create a new custom profile with
              recommended vehicle type <b>{{ exceedVehicleType }}.</b>
            </P>
          </div>
          <div class="form-group col">
            <div
              *ngIf="errorMessage"
              class="alert alert-danger fade show"
              role="alert"
            >
              <i class="modus-icons mr-1" aria-hidden="true">warning</i>
              <div>{{ errorMessage }}</div>
              <button type="button" class="close" data-dismiss="alert">
                <i class="modus-icons notranslate" aria-hidden="true">close</i>
              </button>
            </div>
            <label for="CustomProfileName">Vehicle Routing Profile Name</label>
            <input
              type="text"
              class="form-control"
              [formControl]="CustomProfileName"
              placeholder="My New Profile Name"
              id="profileName"
              [ngClass]="{
                'is-invalid':
                  CustomProfileName.errors && CustomProfileName.dirty
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="CustomProfileName.errors && CustomProfileName.dirty"
            >
              <span *ngIf="CustomProfileName.errors.minlength">
                Name must be greater than 1 character long.
              </span>
              <span *ngIf="CustomProfileName.errors.maxlength">
                Name must be less than 64 characters long.
              </span>
              <span *ngIf="CustomProfileName.errors.invalidName">
                This name is invalid.
              </span>
              <span *ngIf="CustomProfileName.errors.invalidCharacters">
                Valid characters are restricted to letters, numbers, and the
                following: ;()$&@@_.,!'-
              </span>
              <span *ngIf="CustomProfileName.errors.invalidWhiteSpaces">
                Only a single space is allowed between words in a profile name.
              </span>
              <span *ngIf="CustomProfileName.errors.invalidProfileName">
                Please provide a valid profile name.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        [disabled]="CustomProfileName.errors || isSaving"
        (click)="saveNewProfile()"
        class="btn btn-primary"
      >
        <ng-container *ngIf="isSaving; else noSpinner">
          <span
            class="spinner-border mr-1"
            style="height: 16px; width: 16px; color: #fff"
          ></span>
          <span> Saving... </span>
        </ng-container>
        <ng-template #noSpinner>
          <span>Save</span>
        </ng-template>
      </button>
    </div>
  </div>
</ng-template>
